import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OfferTypesEnum } from './pricing-data.data';
import { fetchOffer } from './pricing-data.actions';

@Injectable()
export class PricingDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchOffer(offerType: OfferTypesEnum) {
    this._store.dispatch(fetchOffer(offerType));
  }
}
